<script lang="ts" setup>
import { onMounted, useTemplateRef } from 'vue';

import { useService } from '@nzyme/vue-ioc/useService.js';
import { TransitionFade } from '@nzyme/vue-transitions/TransitionFade.jsx';
import TransitionList from '@nzyme/vue-transitions/TransitionList.vue';
import Loader from '@sigma/assets/loader.svg?component';
import { ActorConnectionService } from '@sigma/client/services/ActorConnectionService.js';
import { useInfiniteScroll } from '@vueuse/core';

import { ChatListStore } from '../../chat/ChatListStore.js';
import PatientMainChatItem from '../components/PatientMainChatItem.vue';

const store = useService(ChatListStore);
const actorConnection = useService(ActorConnectionService);
const el = useTemplateRef('el');

useInfiniteScroll(el, loadMore, {
  canLoadMore: () => store.hasMore,
  distance: 10,
});

onMounted(actorConnection.connect);
onMounted(() => store.refresh());

async function loadMore() {
  await store.loadMore();
}
</script>

<template>
  <div
    ref="el"
    :class="css.page"
  >
    <TransitionList
      v-if="store.chats"
      :class="css.chats"
    >
      <PatientMainChatItem
        v-for="chat in store.chats"
        :key="chat.id.toString()"
        :chat="chat"
      />
    </TransitionList>

    <TransitionFade>
      <Loader
        v-if="!store.chats || store.pending"
        :class="css.loader"
      />
    </TransitionFade>

    <div :class="css.bottomOverlay">
      <div :class="css.gradient" />
    </div>
  </div>
</template>

<style lang="scss" module="css">
.page {
  display: flex;
  flex-direction: column;
  background: $color-white;
  padding-top: $main-header-height;
  flex: 1;
}

.chats {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.loader {
  align-self: center;
  width: 30px;
  height: 30px;
  margin: $spacing-16;
  color: $color-blue-600;
}

.bottomOverlay {
  position: sticky;
  bottom: 0;
  height: 100px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: $spacing-20;
  pointer-events: none;
}

.gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, transparent 0%, rgba(255, 255, 255, 0.87) 40%, rgba(255, 255, 255, 0.93) 100%);
}

.newChatBtn {
  position: relative;
  pointer-events: auto;
  width: 275px;
}
</style>
